import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EcomNetworkUtils } from "@src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service";
import { EcomOlarDataService } from "@src/app/ecom-data-services/ecom-olar-data-service";
import { EComService } from "@src/app/ecom-services/ecom-common.service";
import { EComWebStorage } from "@src/app/ecom-services/ecom-webstorage.services";

@Component({
  selector: 'app-ecom-filters',
  templateUrl: './ecom-filters.component.html',
  styleUrls: ['./ecom-filters.component.scss']
})
export class EcomFiltersComponent implements OnInit {

  FiltersList:any = [];
  olarmerecommended = true;
  dealsanddiscount = true;
  newrestaurant = true;
  filterArrayData = [];
  filterArraySelectedData = [];
  constructor(public ecomOlarDataService: EcomOlarDataService,public router: Router, private webstorage: EComWebStorage, public ecomservice: EComService) {

  }
  ngOnInit() {
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    this.ecomOlarDataService.currentfiltersArray.subscribe(list => {
      this.filterArrayData = list;
    }
    );
    this.ecomOlarDataService.currentfiltersArraySelected.subscribe(list => {
      this.filterArraySelectedData = list;
    }
    );
    this.getDietaryCusines();
  }

  // Method to get the dietary cusines
  getDietaryCusines() {
    
    if (this.filterArrayData.length == 0) {
      this.ecomservice.httpGet(EcomNetworkUtils.GET_DIETARY_CUSINES, '', false).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.status === 200) {
            this.ecomOlarDataService.updatefiltersArraySource(response.listValues);
            this.loadDietaryCusines();
          }
        }
      });
    } else {
      this.loadDietaryCusines();
    }
  }

  // Method load the dietary cusines to list
  loadDietaryCusines() {
    this.FiltersList = [];
    this.ecomservice.loadingPage.loading = false;
    if (this.filterArraySelectedData.length > 0) {
      this.FiltersList = this.filterArraySelectedData;
    } else {
      const dietarycusineslist = this.filterArrayData;
      // Dietary options
      let dietaryOptions = {
        name: 'Dietary Options',
        values: [],
        collapsed: false
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'DIETARY') {
          element.optionName = element.dc_name;
          element.optionSelected = false;
          element.imgsource = '';
          dietaryOptions.values.push(element);
        }
      });
      this.FiltersList.push(dietaryOptions);
      //cuisens option
      let cuisineOptions = {
        name: 'Cuisine',
        values: [],
        collapsed: true
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'CUISINE') {
          let str = element.dc_name.replace('/', '');
          element.imgsource = 'assets/images/cusines/' + str + '.jpeg';
          element.optionName = element.dc_name;
          element.optionSelected = false;
          cuisineOptions.values.push(element);
        }
      });
      this.FiltersList.push(cuisineOptions);
      //Dishes option
      let dishesOptions = {
        name: 'Dishes',
        values: [],
        collapsed: true,
      };
      dietarycusineslist.forEach((element, i) => {
        if (element.dc_type === 'DISHES') {
          let str = element.dc_name.replace('/', '');
          element.imgsource = '';
          element.optionName = element.dc_name;
          element.optionSelected = false;
          dishesOptions.values.push(element);
        }
      });
      this.FiltersList.push(dishesOptions);
    }
  }

  onOlarClick(event, value) {
    switch (value) {
      case '1':
        this.olarmerecommended = !this.olarmerecommended;
        break;
      case '2':
        this.dealsanddiscount = !this.dealsanddiscount;
        break;
      case '3':
        this.newrestaurant = !this.newrestaurant;
        break;
    }
  }

  
  onBackClick() {
    this.ecomservice.loadingPage.loading = true;
    this.router.navigate([this.webstorage.sessionSt_frompage]);
    this.ecomservice.loadingPage.loading = false;
  }

  onFilterClick(filter, filterInex, collapsed) {
    this.FiltersList[filterInex].collapsed = !collapsed;
  }

  onFilterOptionChecked(event, filter, option, filterIndex, optionIndex) {
    this.FiltersList[filterIndex].values[optionIndex].optionSelected = !option.optionSelected;
  }

  onApplyClick() {
    debugger
    this.ecomservice.loadingPage.loading = true;
    this.ecomOlarDataService.updatefiltersArraySelectedSource(this.FiltersList);
    this.router.navigate(['stores']);
    this.ecomservice.loadingPage.loading = false;
  }

  onFilterOptionClick(type, index) {
    debugger
    switch (type) {
      case 'DIETS':
        this.FiltersList[index].collapsed = !this.FiltersList[index].collapsed;
        this.FiltersList.forEach((element, ind) => {
          if (ind !== index) {
            element.collapsed = true;
          }
        });
        break;
      case 'CUISINES':
        this.FiltersList[index].collapsed = !this.FiltersList[index].collapsed;
        this.FiltersList.forEach((element, ind) => {
          if (ind !== index) {
            element.collapsed = true;
          }
        });
        break;
      case 'DISHES':
        this.FiltersList[index].collapsed = !this.FiltersList[index].collapsed;
        this.FiltersList.forEach((element, ind) => {
          if (ind !== index) {
            element.collapsed = true;
          }
        });
        break;
      case 'RESET':
        this.FiltersList[0].collapsed = false;
        this.FiltersList.forEach((element, ind) => {
          if (ind !== index) {
            element.collapsed = true;
          }
          element.values.forEach(option => {
            option.optionSelected = false;
          });
        });
        break;
    }
  }
}